import React from "react";
import { useTranslation } from "react-i18next";
import { useListEdition } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function NameForm({ list, isInvalid, hide }: Props) {
  const { t } = useTranslation();
  const [name, setName] = React.useState(list.name);
  const { isRequestPending, editList } = useListEdition();
  const submit = () => {
    !isRequestPending &&
      editList({
        list,
        nextList: { ...list, name },
      });
    hide();
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <input
        className={styles.input}
        placeholder={t("listForm.name")}
        value={name}
        onChange={({ target }) => setName(target.value)}
        onBlur={submit}
        autoFocus
      />
    </form>
  );
}

export { NameForm };
